import { Box, Button, Stack } from "@mui/material";
import { PencilSimpleLine, Trash } from "@phosphor-icons/react";
import { useCentralStore } from "stores";
import { useMembersStore } from "../stores";

export function PartnersTableDropdownMenu() {
  const openDeleteModal = useCentralStore(state => state.openDeleteModal);
  const openUpdatePartnerModal = useMembersStore(
    state => state.openUpdatePartnerModal
  );

  return (
    <Box>
      <Stack
        sx={{
          minWidth: "168px",
          backgroundColor: "white",
          p: 2
        }}
        spacing={1}
      >
        <Button
          size="small"
          variant="outlined"
          color="primary"
          onClick={openUpdatePartnerModal}
          startIcon={<PencilSimpleLine size={20} />}
        >
          Edit Partner
        </Button>
        <Button
          size="small"
          variant="outlined"
          color="error"
          onClick={openDeleteModal}
          startIcon={<Trash size={20} />}
        >
          Delete Partner
        </Button>
      </Stack>
    </Box>
  );
}
